const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;

export async function notifyReleasedIncomplete({
  session,
  courseId,
  submissionId = null,
  assignmentId = null,
  submissionType = 'assignment'
}) {
  if (!session?.cmsToken) {
    console.warn('Incomplete push skipped: no instructor session token.');
    return;
  }

  const response = await fetch(
    SUPABASE_URL + '/functions/v1/automatic-student-notifications',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        mode: 'incomplete-release',
        cmsToken: session.cmsToken,
        courseId,
        submissionId,
        assignmentId,
        submissionType
      })
    }
  );

  const raw = await response.text();
  let result = null;
  try { result = JSON.parse(raw); } catch {}

  if (!response.ok || !result?.ok) {
    throw new Error(
      result?.error || raw || 'Incomplete push failed.'
    );
  }

  return result;
}
